module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_7016.f5109cad.png";